import { FC } from "react";

import { t } from "i18n/i18n";
import { IconText } from "mds/components/IconText";
import { MenuItem } from "mds/components/Menu";
import { RoundedButton } from "mds/components/buttons/RoundedButton";
import { ArrowTopRightIcon } from "mds/icons";

export type ProjectingButtonProps = {
  onProject: () => Promise<void>;
  isMenuItem?: boolean;
};

export const ProjectingButton: FC<ProjectingButtonProps> = ({ onProject, isMenuItem = false }) => {
  if (isMenuItem) {
    return (
      <MenuItem eventName="Presentation - Open projector view" onClick={onProject}>
        <IconText
          iconStart={<ArrowTopRightIcon />}
          text={t("page_presenting_menu.start_projecting")}
        />
      </MenuItem>
    );
  }

  return (
    <RoundedButton
      eventName="Presentation - Open projector view"
      kind="primary"
      title={t("page_presenting_menu.start_projecting")}
      onClick={onProject}
    >
      <IconText
        iconStart={<ArrowTopRightIcon className="text-white" />}
        text={t("page_presenting_menu.start_projecting")}
      />
    </RoundedButton>
  );
};
